import {
  Button,
  Checkbox,
  CircularProgress,
  InputAdornment,
  TextField,
} from "@material-ui/core";
import { useFormik } from "formik";
import {
  ArrowBendDownRight,
  Chats,
  ClipboardText,
  FilmSlate,
  PaperPlaneTilt,
  X,
} from "phosphor-react";
import React, { createRef, useEffect, useState } from "react";
import * as yup from "yup";
import { fget, fpost } from "../../../../API/callsAPI";
import ViewComments from "../../CommentBox/ViewComments/ViewComments";
import StatusDropDown from "../../StatusDropDown/StatusDropDown.component";
import UserAvatar from "../../UserAvatar/UserAvatar.component";
import ReviewAgentTask from "../ReviewAgentTask/ReviewAgentTask";
import useStyles from "./LinkedTaskAndComments.style";

const LinkedTaskAndComments = ({
  linkedTask,
  taskComments,
  taskStatusList,
  projectId,
  updateLinkedTaskAndComments,
  loggedInUser,
  selectedVersion,
  version_type,
}) => {
  const classes = useStyles();
  const inputRef = createRef();
  const [selectedTabOnTaskPart, setSelectedTabOnTaskPart] =
    useState("agent-task");
  const [experimentalSettings, setExperimentalSettings] = useState({});
  const [currentUser, setCurrentUser] = useState({});
  const [repliedTo, setRepliedTo] = useState({});
  const [showReplay, setShowReplay] = useState(null);
  const [isCommentPosting, setIsCommentPosting] = useState(false);
  const [linkVersion, setLinkVersion] = useState(true);
  //Validators
  const CommentsValidationScheme = yup.object({
    comments: yup
      .string("String required")
      .label("comments")
      .min(1, "Too Short!")
      .max(100, "Maximum Character Limit: 50")
      .required(),
  });
  const formik = useFormik({
    initialValues: {
      comments: "",
    },
    validationSchema: CommentsValidationScheme,
    onSubmit: async (values) => {
      let formData = new FormData();
      formData.append("name", linkedTask.name);
      formData.append(
        "description",
        linkVersion
          ? `<version>${selectedVersion?.name}<version> ${values.comments}`
          : values.comments
      );
      formData.append("task", linkedTask.id);
      formData.append("id", projectId);
      if (repliedTo?.id) {
        formData.append("replied_to", repliedTo?.id);
      }

      let data = {
        url: `trackables/task-comment/`,
        data: formData,
      };
      try {
        setIsCommentPosting(true);
        const res = await fpost(data);
        if (res.status === 200 || 201) {
          formik.values.comments = "";
          updateLinkedTaskAndComments();
          setShowReplay(repliedTo?.id);
          setRepliedTo({});
          setIsCommentPosting(false);
        }
      } catch (err) {
        console.log(err);
        setRepliedTo({});
        setIsCommentPosting(false);
      }
    },
  });

  useEffect(() => {
    getLoggedInUser();
  }, [projectId]);

  const getLoggedInUser = async () => {
    try {
      const usersRes = await fget({
        url: `project/${projectId}/users/`,
      });
      setCurrentUser(
        usersRes?.data?.results?.find((res) => res.id === loggedInUser?.id)
      );
    } catch (error) {
      console.log(error);
    }
  };

  useEffect(() => {
    inputRef?.current?.focus();
  }, [repliedTo?.id]);

  // <ReviewAgentTask />
  useEffect(() => {
    const set = localStorage.getItem("experimentalSettings");
    if (set) {
      const parsed = JSON.parse(set);
      setExperimentalSettings(parsed);
    }
  }, []);

  return (
    <div style={{ height: "98%" }}>
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "space-between",
          marginBottom: "4px",
        }}
      >
        <span className={classes.taskName}>{linkedTask?.name}</span>
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          {/* <Button
            onClick={() => setSelectedTabOnTaskPart("task-comment")}
            className={
              selectedTabOnTaskPart === "task-comment" && classes.selectedButton
            }
          >
            <Chats size={22} />
          </Button> */}
          {/* {experimentalSettings?.isReviewAgentEnabled ? (
            <Button
              onClick={() => setSelectedTabOnTaskPart("agent-task")}
              className={
                selectedTabOnTaskPart === "agent-task" && classes.selectedButton
              }
            >
              <ClipboardText size={22} />
            </Button>
          ) : (
            ""
          )} */}
          <Button
            onClick={() => setSelectedTabOnTaskPart("agent-task")}
            className={
              selectedTabOnTaskPart === "agent-task" && classes.selectedButton
            }
          >
            <ClipboardText size={22} />
          </Button>
          <StatusDropDown
            statusList={taskStatusList}
            currStatus={linkedTask?.status}
            updateRefreshCounter={updateLinkedTaskAndComments}
            url={`trackables/task/${linkedTask?.id}/`}
          />
        </div>
      </div>

      {selectedTabOnTaskPart === "task-comment" ? (
        <div
          className={classes.root}
          style={{
            height: "92%",
          }}
        >
          <div
            style={{
              height: repliedTo?.id ? "82%" : "87%",
              overflowY: "auto",
              // padding: "20px",
            }}
          >
            <ViewComments
              comments={taskComments}
              loggedInUser={currentUser}
              updateCommentsRefreshCounter={updateLinkedTaskAndComments}
              setRepliedTo={setRepliedTo}
              showReplay={showReplay}
              setShowReplay={setShowReplay}
            />
          </div>
          <div>
            {repliedTo?.id ? (
              <div className={classes.flexBetween}>
                <div className={classes.replyingToText}>
                  <ArrowBendDownRight size={20} className={classes.text} />
                  <span className={classes.text}>Replying to :</span>
                  <span>
                    {repliedTo?.author?.first_name}{" "}
                    {repliedTo?.author?.last_name}
                  </span>
                </div>
                <X
                  size={20}
                  className={classes.icon}
                  onClick={() => setRepliedTo({})}
                />
              </div>
            ) : (
              ""
            )}
          </div>
          <form enctype="multipart/form-data" onSubmit={formik.handleSubmit}>
            <div
              style={{
                display: "flex",
              }}
            >
              <div
                onKeyDown={(event) => event.stopPropagation()}
                className={classes.submitCommentField}
              >
                <div className={classes.linkTaskOption}>
                  <FilmSlate size={18} />
                  <span>Link Version</span>
                  <Checkbox
                    size="small"
                    style={{ padding: "2px" }}
                    checked={linkVersion}
                    onChange={() => setLinkVersion(!linkVersion)}
                  />
                </div>
                <TextField
                  type="text"
                  id="comments"
                  placeholder={"Type a Comment..."}
                  fullWidth
                  name="comments"
                  value={formik.values.comments}
                  onChange={formik.handleChange}
                  error={Boolean(formik.errors.comments)}
                  InputProps={{
                    disableUnderline: true,
                    startAdornment: (
                      <InputAdornment position="start">
                        <UserAvatar
                          avatar={currentUser?.avatar}
                          firstName={currentUser?.first_name}
                          lastName={currentUser?.last_name}
                        />
                      </InputAdornment>
                    ),
                    /* endAdornment: (
                          <InputAdornment position="end">
                            <label className={classes.attachmentLabel} for={type}>
                              <PaperclipHorizontal
                                size={20}
                                className={classes.fileInputIcon}
                              />
                            </label>
                          </InputAdornment>
                        ), */
                  }}
                  inputProps={{
                    ref: inputRef,
                  }}
                  /* helperText={
                        formik.errors.comments ? formik.errors.comments : null
                      } */
                />
              </div>
              <Button
                type="submit"
                className={classes.submitButton}
                disabled={isCommentPosting ? true : false}
              >
                {isCommentPosting ? (
                  <CircularProgress color="primary" size={27} />
                ) : (
                  <PaperPlaneTilt size={22} />
                )}
              </Button>
            </div>
          </form>
        </div>
      ) : (
        <ReviewAgentTask
          linkedTask={linkedTask}
          selectedVersion={selectedVersion}
          version_type={version_type}
          projectId={projectId}
        />
      )}
    </div>
  );
};

export default LinkedTaskAndComments;
